import {
    Datagrid, DateField, List, TextField, ReferenceField,
    BooleanField, Pagination, BooleanInput,
    ReferenceInput,
    AutocompleteInput
} from "react-admin";

const ConversationPagination = () => <Pagination rowsPerPageOptions={[25, 50, 100]} />;

const filters = [
    <ReferenceInput label="User" source="users" reference="user" allowEmpty alwaysOn>
        <AutocompleteInput label="User" optionText="profile.nickname"
            filterToQuery={(txt) => ({ profile: { nickname: txt } })}
            size='small'
            // suggestionLimit={10}
            />
    </ReferenceInput>,
    <BooleanInput label="Show Deleted" source="withDeleted" alwaysOn size='medium' sx={{ padding: "4px", marginInlineStart:"16px" }} />
]

export const ConversationList = () => (
    <List
        perPage={25}
        pagination={<ConversationPagination />}
        filter={{ lastSent: true }}
        filters={filters}
        sort={{ field: 'updatedAt', order: 'DESC' }}
        exporter={false}
    >
        <Datagrid rowClick="show">
            {/* <TextField source="id" /> */}
            {/* <TextField source="usersInbox[0]._id"/> */}
            <ReferenceField label="U1" source="usersInbox[0]._id" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            {/* <TextField source="usersInbox[0].sent" /> */}

            {/* <TextField source="usersInbox[1]._id"/> */}
            <ReferenceField label="U2" source="usersInbox[1]._id" reference="user">
                <TextField source="profile.nickname" />
            </ReferenceField>
            {/* <TextField source="usersInbox[1].sent" /> */}

            {/* <TextField source="usersInbox[0]._id"/>
            <TextField source="usersInbox[1]._id"/> */}

            {/* <NumberField source="count" /> */}

            <DateField source="updatedAt" />
            {/* <TextField source="lastMessage" /> */}
            {/* <DateField source="lastSent" /> */}
            <DateField source="createdAt" />
            <BooleanField source="deleted" />
            {/* <ArrayField source="usersInbox"><SingleFieldList><ChipField source="unread" /></SingleFieldList></ArrayField> */}
            {/* <NumberField source="unread" /> */}

        </Datagrid>
    </List>
);